import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import resultImg from "../../styles/images/img_withdrawal_result.png";

import OnePageLayout from "../../components/layout/OnePageLayout";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import { getToken } from "../../components/hooks/authFunc";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const WithDrawalResult = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const accessToken = getToken();
  const handleLogout = () => {
    const params = {};
    dispatch(authActions.fetchLogout({ accessToken, params }));
  };

  return (
    <OnlyHeaderLayout title="회원탈퇴">
      <Section>
        <Content>
          <TextDiv>
            <h3>
              정상적으로
              <br />
              회원 탈퇴되었습니다.
            </h3>
          </TextDiv>
          <ImgWrap margintop="12.3" imgwidth="24.5">
            <img src={resultImg} alt="" />
          </ImgWrap>
        </Content>
        <Btns>
          <ButtonL onClick={handleLogout}>확인</ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default WithDrawalResult;
